import React, { PureComponent } from 'react';
import i10n from '../i10n';
import { AsyncSVG } from './AsyncSVG';

export class DidYouKnow extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        if (!i10n[`_VIEW_DIDYOUKNOW_TITLE`]) {
            return (null);
        }

        return (
            <div className="row ave-row-small">
                <div className="col-md-12 did-you-know-main-tile">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <h3 className="title-fancy title-small mb-5">
                                <span className="title-fancy-icon"><AsyncSVG className="link-arrow" src='/images/title-icon.svg' /></span>
                                {i10n[`_VIEW_DIDYOUKNOW_TITLE`]}
                            </h3>
                            <div className="row">
                                {
                                    this.props.columns.map((column, index) => (
                                        <>
                                            <div className="col-sm-12 col-md-12 col-lg-12 mb-4">
                                                <div key={`title-${index}`} className={`${column.class}-embed-title did-you-know-subtitle`}>
                                                    <span style={{ height: "auto" }} className="did-you-know-subtitle-content" >
                                                        {column.title}
                                                    </span>
                                                </div>
                                                <div key={`content-${index}`} className={`my-2 did-you-know-card-content`}>
                                                    {
                                                        column.isReactComponent &&
                                                        React.createElement(column.body)
                                                        ||
                                                        column.body
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}